import { Box } from '@mui/material';

export const GameTitle = () => {
  return (
    <Box
      component="img"
      src="/whalex-plink-title.png" // ✅ correct public folder path
      alt="WhaleX Plink"
      sx={{
        width: { xs: 300, md: 400 },
        height: { xs: 130, md: 400 },
        objectFit: 'contain',
        zIndex: 333,
        mixBlendMode: 'normal',
        filter: 'drop-shadow(0 0 1px rgba(0,0,0,0))',
        animation: 'glow 2s ease-in-out infinite',
        position: 'absolute',
        top: { xs: 110, md: 80 }, // ⬆️ moved higher only on laptop
        left: { xs: 'calc(55% - 10px)', md: 'calc(80% - 20px)' },
        transform: 'translateX(-50%)',
        '@keyframes glow': {
          '0%, 100%': {
            filter: 'drop-shadow(0 0 10px rgba(65, 217, 215, 0.5))',
          },
          '50%': {
            filter: 'drop-shadow(0 0 20px rgba(65, 217, 215, 0.8))',
          },
        },
      }}
    />
  );
};
